import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUniversities } from '../../services/universityService';

const EssayCoach = () => {
  const [localSchool, setLocalSchool] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [validationError, setValidationError] = useState('');
  const navigate = useNavigate();
  
  const { data: universities, isLoading, error } = useUniversities();

  const handleAnalyze = () => {
    if (!localSchool) {
      setValidationError('Please select a university before proceeding.');
      return;
    }
    setValidationError('');
    navigate(`/analyze/${localSchool}`);
  };

  const handleUniversitySelect = (id: number, name: string) => {
    setLocalSchool(id.toString());
    setSearchTerm(name);
    setShowDropdown(false);
    setValidationError('');
  };

  const filteredUniversities = universities?.filter(uni =>
    uni.name.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="max-w-4xl mx-auto w-full">
          <div className="rounded-xl shadow-lg py-16" style={{ background: 'var(--surface-primary)' }} data-tour="essay-coach-dropdown">
            <div className="text-center">
              <div className="text-xl">Loading universities...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="max-w-4xl mx-auto w-full">
          <div className="rounded-xl shadow-lg py-16" style={{ background: 'var(--surface-primary)' }}>
            <div className="text-center">
              <div className="text-xl text-red-600">Error loading universities</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center">
      <div className="max-w-4xl mx-auto w-full">
        <div className="rounded-xl shadow-lg py-16" style={{ background: 'var(--surface-primary)' }} data-tour="essay-coach-dropdown">
          <div className="text-center">
            <h2 className="text-2xl font-semibold mb-8">Select University</h2>

            <div className="flex flex-col gap-6 items-center max-w-md mx-auto w-full">
              <div className="w-full relative">
                <input
                  type="text"
                  value={searchTerm}
                  onFocus={() => setShowDropdown(true)}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowDropdown(true);
                  }}
                  className="w-full px-4 py-1 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ borderColor: 'var(--border-primary)', background: 'var(--surface-primary)', color: 'var(--text-primary)' }}
                />
                {showDropdown && (
                  <div className="absolute z-10 mt-1 w-full max-h-36 overflow-y-auto border rounded-md shadow-lg" style={{ background: 'var(--surface-primary)', borderColor: 'var(--border-primary)' }}>
                    {filteredUniversities.map((uni) => (
                      <div
                        key={uni.id}
                        onClick={() => handleUniversitySelect(uni.id, uni.name)}
                        className="px-4 py-2 cursor-pointer hover:bg-[var(--surface-hover)]"
                        style={localSchool === uni.id.toString() ? { background: 'var(--surface-hover)', fontWeight: 600 } : {}}
                      >
                        {uni.name}
                      </div>
                    ))}
                    {filteredUniversities.length === 0 && (
                      <div className="px-4 py-2 text-sm" style={{ color: 'var(--text-tertiary)' }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}
              </div>

              {validationError && (
                <div className="w-full text-red-600 text-sm text-center bg-red-50 border border-red-200 rounded-md px-3 py-2">
                  {validationError}
                </div>
              )}

              <button
                className="w-full h-10 text-base rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-200 mt-1"
                onClick={handleAnalyze}
              >
                {localSchool
                  ? `View Details for ${universities?.find(u => u.id.toString() === localSchool)?.name || ''}`
                  : 'View Application Details'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EssayCoach;
